<template lang="pug">
div
  AuthHeader
  main.promo
    .promo__content
      h1.promo__title {{ $t('promo.title') }}
      .promo__logo
        img(src="~@/assets/images/promo-logo.png")
      .promo__button
        button.button-big(@click="openReg") {{ getButtonText }}

    .promo__video
      video(preload="auto", muted="", autoplay="", loop="", data-keepplaying="", poster="~@/assets/images/promo-bg.jpg")
        source(src="~@/assets/video/bg.mp4", type="video/mp4")
        source(src="~@/assets/video/bg.webm", type="video/webm")
  PromoFooter
  Registration(:showHeading="false")
  PresentPopup(v-if="show_present_popup")

</template>

<script>
import env from "@chronos/frontend-base/src/libs/tools/Environment";
import AuthHeader from "@static_promo_pages/common/components/auth-header/vue/AuthHeader.vue";
import PromoFooter from "@static_promo_pages/common/components/footer/vue/Footer.vue";
import Registration from "@chronos/frontend-base/src/components/register/mygames/ProjectReg";
import PresentPopup from "./blocks/PresentPopup.vue";
import GTM from "@chronos/frontend-base/src/libs/api/GTM";
import UserMixin from "@chronos/frontend-base/src/mixins/user/UserMixin";
export default {
  name: "PromoIndex",

  components: {
    AuthHeader,
    PromoFooter,
    Registration,
    PresentPopup,
  },

  mixins: [UserMixin],

  data() {
    return {
      show_present_popup: false,
    };
  },

  computed: {
    getButtonText() {
      return this.isUserInProject ? this.$t("promo.button_auth") : this.$t("promo.button_notauth");
    },
  },

  created() {
    document.addEventListener("init_vue_components", () => {
      this.initPromo();
    });
  },

  methods: {
    async initPromo() {
      await this.$store.dispatch("global/auth");
      this.$api.userService
        .getUserData()
        .run()
        .then(response => {
          this.processingData(response.data);
          if (this.$authService.user && this.$authService.user.newbie) {
            GTM.gtmComplete(["ch.registration.finish"], "3").then(() => {
              this.redirectToSite();
            });
          }
          if (response.data.error) {
            this.show_present_popup = true;
          }
        });
    },

    openReg() {
      if (this.isUserNotAuthed) {
        this.$authService.showSignup();
      } else if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      } else {
        this.redirectToSite();
      }
    },

    redirectToSite() {
      window.location.href = env.getHomePage() + "about";
    },
  },
};
</script>
